import { render, staticRenderFns } from "./AddBlackList.vue?vue&type=template&id=49f18701&"
import script from "./AddBlackList.vue?vue&type=script&lang=js&"
export * from "./AddBlackList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports